import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SendInvoice = async (invoiceID,navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/Invoice/send?invoiceID=${invoiceID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`          
        },
      });
      
      const data = await response.json();        

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
      } else {
        return data;
      }       
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
